import {
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output,
  ViewChild,
} from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { TranslateService } from '@ngx-translate/core';
import { DatePipe } from '@angular/common';
import { ResponseState } from '../../models/support/response-state';
import { SharedService } from '../../services/other/shared.service';
import { ToastrService } from 'ngx-toastr';
import { ClientService } from 'src/app/services/client/client.service';
import { TransactionsSecondService } from 'src/app/services/transaction/transactions-second.service';
import { ClientLastVisitInfoSearchCriteria } from 'src/app/models/classes/transactions/client-last-visit-search-criteria';
import { ClientLastVisitInfoDTO, ClientLastVisitInfoItemDTO } from 'src/app/models/classes/transactions/client-last-visit-DTO';
import { VisitType } from 'src/app/models/enums/visit-type';

@Component({
  selector: 'app-modal-client-visit-info',
  templateUrl: './modal-client-visit-info.component.html',
  styleUrls: ['./modal-client-visit-info.component.scss'],
  providers: [DatePipe],
})
export class ModalClientVisitInfo implements OnInit {

  @Input() BillId: number;
  @Input() BookingId: number;

  public LoadingGetClientLastVisit: boolean;
  public clientLastVisitInfo: ClientLastVisitInfoDTO;

  constructor(
    public activeModal: NgbActiveModal,
    public translate: TranslateService,
    private transactionsSecondService: TransactionsSecondService,
    public clientService: ClientService,
    public sharedService: SharedService,
    public toaster: ToastrService
  ) { }

  ngOnInit(): void {
    this.GetClientLastVisitInfo();
  }

  public get visitType(): typeof VisitType {
    return VisitType;
  }


  isContainsSecondEmployee(items: ClientLastVisitInfoItemDTO[]): boolean {
    return items?.some(i => i.SecondEmployeeName && i.SecondEmployeeName.length > 0);
  }


  divName;
  printPage() {
    this.divName = 'printGymMembershipInfo';
    console.log(this.divName);

    let printContents = document.getElementById(this.divName).innerHTML;
    let originalContents = document.body.innerHTML;

    document.body.innerHTML = printContents;
    window.print();
    document.body.innerHTML = originalContents;
    window.location.reload();
  }

  GetClientLastVisitInfo() {

    this.LoadingGetClientLastVisit = true;

    let criteria: ClientLastVisitInfoSearchCriteria = new ClientLastVisitInfoSearchCriteria();

    criteria.BillId = this.BillId;
    criteria.BookingId = this.BookingId;

    this.transactionsSecondService
      .GetClientLastVisitInfo(criteria)
      .subscribe((response) => {
        if (response.State == ResponseState.Success) {
          this.clientLastVisitInfo = response.Result;
        }
        this.LoadingGetClientLastVisit = false;
      });
  }
}
